import { combineReducers, configureStore,type UnknownAction } from '@reduxjs/toolkit'

import { setupListeners } from '@reduxjs/toolkit/query'
import { userApi } from './OkOkStore'


const combinedReducer = combineReducers({
  [userApi.reducerPath]: userApi.reducer,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state:any, action:UnknownAction) => {
  if (action.type === 'login/logout') { // check for action type
    state = undefined;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return combinedReducer(state, action);
};


const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware(
    {
      immutableCheck: false,
      serializableCheck: false,
    }
  ).concat(
      userApi.middleware,

    )
})

setupListeners(store.dispatch)
// Get the type of our store variable
export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']
export default store;

